<h2 mat-dialog-title>{{ 'case.inputs.static-site-dialog.title' | translate | capitalize }}</h2>
<mat-dialog-content class="dialog-content">
  @if (!loading()) {
    @if (sites().length > 0) {
      <app-list
        title=""
        [columns]="columns"
        [data]="sites()"
        [addButton]="false"
        [shadow]="false"
        (rowClick)="select($event)">
      </app-list>
    } @else {
      <p class="empty-state">{{ 'case.inputs.static-site-dialog.none' | translate | capitalize }}</p>
    }
  } @else {
    <app-skeleton-list></app-skeleton-list>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="cancel()">{{ 'general.words.cancel' | translate | capitalize }}</button>
</mat-dialog-actions>
